import React from "react";
import { Typography, Box, Paper, Link } from "@mui/material";
import { useTranslation } from "../../../i18n/useTranslation";

interface ShippingCostProps {
  transportType: string;
  amountFreeDelivery: number;
}

const CalculationShippingCosts: React.FC<ShippingCostProps> = ({ transportType, amountFreeDelivery }) => {
    const { t } = useTranslation('translation');
    const mainColor = "#4caf50";
    const transportColor = "#1976d2";
    const amountColor = "#ff9800";
    const lang = localStorage.getItem("lang") || "en";
    const url = `${window.location.origin}/${lang}/Home/ShipmentConditions`;
    return (
        <Paper
        elevation={2}
        sx={{
            p: 2,
            mb: 1,
            borderLeft: `5px solid ${mainColor}`,
            backgroundColor: "#f9fff9",
        }}
        >
        <Typography variant="body1">
            <Box component="span" sx={{ color: "#333" }}>{t('SHIPPING_COST_FOR') + ' '}</Box>
            <Box component="span" sx={{ color: transportColor, fontWeight: 500 }}>{t(transportType)}</Box>
            <Box component="span" sx={{ color: "#333" }}> – </Box>
            <Box component="span" sx={{ color: amountColor, fontWeight: 700 }}>
            {amountFreeDelivery.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} EUR
            </Box>
            <Box component="span" sx={{ color: "#333" }}>{' ' + t('AMOUNT_OF_PRODUCTS_TO_REACH_FRANCO')}</Box>
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
            <Link 
                href={url} target="_blank" 
                rel="noopener" 
                sx={{ fontWeight: 500, color: "#333" }}>
                {t('CLICK_HERE_TO_SEE_OUR_SHIPMENT_CONDITIONS')}
            </Link>
        </Typography>
        </Paper>
    );
};

export default CalculationShippingCosts;
